import {
    insertCalendarIdInOrderedList,
    insertCalendarGroupInOrderedList,
    deleteCalendarIdFromOrderedList,
    deleteCalendarGroupFromOrderedList,
} from '../actions/publicActions';
import getStore from '../store/store';
import { mutator } from 'satcheljs';
import { findInArray } from 'owa-calendar-data-utils/lib/findInArray';

export const insertCalendarIdInOrderedListMutator = mutator(
    insertCalendarIdInOrderedList,
    ({ index, idToAdd }) => {
        const store = getStore();
        // Add calendar list item
        if (index > -1) {
            // Item already exists
            store.calendarIdOrderedList.splice(index, 0, idToAdd);
        } else {
            // Item doesnt exist
            store.calendarIdOrderedList.push(idToAdd);
        }

        store.calendarIdOrderedList = removeDuplicatesFromOrderedList(store.calendarIdOrderedList);
    }
);

export const deleteCalendarIdFromOrderedListMutator = mutator(
    deleteCalendarIdFromOrderedList,
    ({ calendarIdKey }) => {
        removeEntryFromOrderedIdList(getStore().calendarIdOrderedList, calendarIdKey);
    }
);

export const insertCalendarGroupInOrderedListMutator = mutator(
    insertCalendarGroupInOrderedList,
    ({ index, idToAdd }) => {
        const store = getStore();
        // Add calendar group list item
        if (index > -1) {
            // Item already exists
            store.calendarGroupKeyOrderedList.splice(index, 0, idToAdd);
        } else {
            // Item doesnt exist
            store.calendarGroupKeyOrderedList.push(idToAdd);
        }

        store.calendarGroupKeyOrderedList = removeDuplicatesFromOrderedList(
            store.calendarGroupKeyOrderedList
        );
    }
);

export const deleteCalendarGroupFromOrderedListMutator = mutator(
    deleteCalendarGroupFromOrderedList,
    ({ groupKey }) => {
        removeEntryFromOrderedIdList(getStore().calendarGroupKeyOrderedList, groupKey);
    }
);

function removeDuplicatesFromOrderedList(orderedList: string[]): string[] {
    const dedupedOrderedList = [];
    const uniqueKeyMapping = new Map();

    orderedList.forEach(calendarId => {
        if (!uniqueKeyMapping.has(calendarId)) {
            dedupedOrderedList.push(calendarId);
            uniqueKeyMapping.set(calendarId, null);
        }
    });

    return dedupedOrderedList;
}

function removeEntryFromOrderedIdList(orderedIdList: string[], EntryKey: string) {
    const orderedIdListFindResult = findInArray(orderedIdList, id => id === EntryKey);

    if (orderedIdListFindResult) {
        orderedIdList.splice(orderedIdListFindResult.index, 1);
    }
}
